import { render, staticRenderFns } from "./liveData.vue?vue&type=template&id=426bf7c5&scoped=true&"
import script from "./liveData.vue?vue&type=script&lang=js&"
export * from "./liveData.vue?vue&type=script&lang=js&"
import style0 from "./liveData.vue?vue&type=style&index=0&id=426bf7c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426bf7c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('426bf7c5')) {
      api.createRecord('426bf7c5', component.options)
    } else {
      api.reload('426bf7c5', component.options)
    }
    module.hot.accept("./liveData.vue?vue&type=template&id=426bf7c5&scoped=true&", function () {
      api.rerender('426bf7c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/liveData/liveData.vue"
export default component.exports